import { render, staticRenderFns } from "./EditUserForm.vue?vue&type=template&id=79c49c12&"
import script from "./EditUserForm.vue?vue&type=script&lang=js&"
export * from "./EditUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports